export default __webpack_public_path__ + "f32ab719d07bd4244a1e88ae68dd9888.svg";